exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.Menu-Schedule-Verbiage {\n  background: #fff8de;\n  width: 100%;\n  min-height: 58px;\n}\n", ""]);

